import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'enumKeys',
  standalone: false
})
export class EnumKeysPipe implements PipeTransform {
  transform(value: any, onlyNumericKeys: boolean = false) : any {
    let keys = [];
    for (var enumMember in value) {
      if (!onlyNumericKeys || !isNaN(parseInt(enumMember, 10))) {
        keys.push({key: parseInt(enumMember, 10), value: value[enumMember]});
        // Uncomment if you want log
        // console.log("enum member: ", value[enumMember]);
      } 
    }
    return keys;
  }
}